import { store } from "@/store"
import { validateField } from "@/utils/location"
import { validatePhone } from "@/js/helperV2"
import {
  getCart,
  orderSubmit,
  panConsentUpdate,
  setCart,
  setCartCount,
  discount,
  shipmentUpdate,
  createCart,
} from "@/store/features/cartSlice"
import { refreshCart } from "@/components/checkout/checkoutHelperFunction"
import { getShortenedUrl } from "@/utils/helper"
import { getConfig } from "@/constants/config"
import { showToast } from "@/store/features/genericSlice"
import { gtmPurchaseEvent } from "../OrderConfirmation/analytics"

const getShippingEventInfo = (type, needJSON = false) => {
  const eventInfo = {
    eventAction: `checkout:shipping:${type}`,
    eventName: `checkout:shipping:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const isBackOrder = (shipItems = []) => {
  const arr = []
  shipItems.forEach(item => {
    const isTrue =
      item?.backOrder && item.leadTime && item.quantity > item.availableQty
    arr.push(isTrue)
  })
  return arr.includes(true)
}

export const validateInput = async (field, val = "", data, i18n) => {
  const value = val?.trim()
  const gstRegex = /[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][A-Z0-9][A-Z][A-Z0-9]/;
  const gstinTextRegex = /gstin/i; // case-insensitive
  switch (field) {
    case "fname":
    case "firstName":
    case "lastName":
      if (!value) {
        return field === "fname" || field === "firstName"
          ? i18n.fnameError
          : i18n.lnameError
      } else if (!(await validateField("name", value))) {
        return i18n.nameValidation
      }
      break
    case "email":
      if (!data.email.value) return i18n.noEmailError
      else if (!(await validateField("email", value))) return i18n.validEmail
      break
    case "phone":
      if (!value || !validatePhone(value)) return i18n.validPhone
      break
    case "address1":
      if (!value) {
        return i18n.addressError
      } else if (/[%&\\]/g.test(value)) {
        return i18n.speicalCharError
      }
      else if(gstRegex.test(value.toUpperCase()) || gstinTextRegex.test(value.toUpperCase())){
        return i18n.gstNumberError
      }
      break
    case "city":
      if (!value) return i18n.cityError
      else if (!(await validateField("city", value))) return i18n.cityValidation
      break
    case "state":
      if (!value) return i18n.stateError
      break
    case "zipcode":
      if (!value) return i18n.zipcodeError
      else if (value.length < 5) return i18n.validZipcode
      break
    default:
      return
  }
}

const setPanConsent = async (pancardValue, cb, errorCb) => {
  const payload = {
    actions: [
      {
        action: "setCustomType",
        type: {
          key: "order",
          typeId: "type",
        },
      },
      {
        action: "setCustomField",
        name: "pancard",
        value: `${pancardValue}`,
      },
    ],
  }
  await store
    .dispatch(panConsentUpdate(payload))
    .unwrap()
    .then(res => {
      store.dispatch(setCart(res))
      cb(res)
    })
    .catch(error => {
      errorCb(error)
    })
}

export const checkInactivePromos = async (cb, cb1) => {
  // const actions = []
  // let actionData
  // const cart = store?.getState()?.cart?.cart
  // const { discountCodes = [] } = cart
  // discountCodes
  //   .filter(item => item.state !== "MatchesCart")
  //   .map(item => {
  //     actions.push({
  //       action: "removeDiscountCode",
  //       discountCode: { typeId: "discount-code", id: item.discountCode?.id },
  //     })
  //     actionData = [...actions]
  //   })
  // if (actionData?.length > 0) {
  //   store
  //     .dispatch(discount({ actions: actionData }))
  //     .unwrap()
  //     .then(res => {
  //       if (res && res.type === "Cart") {
  //         store
  //           .dispatch(addToCart({ actions: [{ action: "calculateTax" }] }))
  //           .unwrap()
  //           .then(resp => {
  //             if (resp && resp.type === "Cart") {
  //               store.dispatch(setCart(res))
  //               store.dispatch(setCartCount(res.lineItems))
  //               createOrder(cb, cb1)
  //             }
  //           })
  //       }
  //     })
  // } else {
  submitOrder(cb, cb1)
  // }
  // return actionData
}

// export const createOrder = async (
export const submitOrder = async (
  cb,
  cb1,
  isPaymentPending = false,
  setIsPaymentPending = () => {}
) => {
  const cart = store.getState()?.cart
  const {
    general: { siteName = "", orderConfirmPath = "/", homepageUrl = "/" } = {},
  } = await getConfig()

  const orderConfirmUrl = await getShortenedUrl(orderConfirmPath)
  const homePagePath = await getShortenedUrl(homepageUrl)

  const {
    id: cartId,
    version,
    shippingAddress: { postalCode: pincode = "" },
    promoCode
  } = cart.cart
  const { paymentId } = cart
  const _appliedCouponCode = promoCode[0]?.code
  const payload = {
    cartId,
    version,
    pincode,
    paymentId,
  }

  store
    .dispatch(orderSubmit(payload))
    .unwrap()
    .then(async res => {
      if (res) {
        const orderNumber = res.order?.orderNumber ?? ""
        const orderId = res.order?.id ?? ""
        const email = res.order?.customerEmail ?? ""
        const date = res.order?.createdAt ?? ""
        const total = res.order?.totalPrice?.centAmount ?? ""
        const fractionDigits = res.order?.totalPrice?.fractionDigits ?? 2
        const shippingAddress = res.order?.shippingAddress ?? {}

        gtmPurchaseEvent(
          orderId,
          email,
          shippingAddress,
          (total / 10 ** fractionDigits).toString(),
          _appliedCouponCode
        )

        const base64Str = btoa(JSON.stringify({ email, date, total }))
        const redirectionLink = `${orderConfirmUrl}?orderNumber=${orderNumber}&q=${base64Str}&oId=${orderId}`
        const purchasePathAnalytics = getPurchasePathAnalytics(
          res.order?.lineItems
        )
        cb1 && cb1(redirectionLink, purchasePathAnalytics)

        const isRegCheckout = window.localStorage.getItem("regular-checkout")
        if (isRegCheckout === "true") {
          window.localStorage.removeItem("active-cart")
          window.localStorage.removeItem("regular-checkout")
          await store.dispatch(
            createCart({
              currency: "INR",
            })
          )
        }

        window.localStorage.setItem("buy-now-init", "completed")
        window.localStorage.removeItem("buy-now-cart")

        window.history.replaceState(null, null, homePagePath)
        window.location.href = redirectionLink
      } else {
        cb && cb(false) // enable Place Order CTA on failure
      }
    })
    .catch(() => {
      store
        .dispatch(getCart())
        .unwrap()
        .then(async () => {
          await refreshCart()
          await store.dispatch(
            showToast({
              message: "Something went wrong. Please try again...",
              isVisible: true,
            })
          )
          setTimeout(location.reload(), 1000)
        })
      cb && cb(false)
    })
}

export const setBillingAddressCheckout = async address => {
  try {
    const addr =
      typeof window?.structuredClone === "function"
        ? window?.structuredClone(address)
        : JSON.parse(JSON.stringify(address))

    if (addr.state) {
      addr.region = addr.state
      delete addr.state
    }

    const actions = [
      {
        action: "setBillingAddress",
        address: addr,
      },
    ]
    await store.dispatch(shipmentUpdate({ actions }))
  } catch (ex) {
    console.log(ex)
  }
}

const getPurchasePathAnalytics = lineItems => {
  const sections = []

  lineItems.forEach(item => {
    const itemSection = item.custom?.fields?.section
    if (itemSection) {
      sections.push(itemSection)
    }
  })

  if (sections.length) {
    return Array.from(new Set(sections)).join(";")
  }

  return "n/a"
}

export const isKempDiscountApplied = () => {
  const cart = store?.getState()?.cart?.cart
  const discountCodes = cart?.discountCodes || []

  return discountCodes.some(
    code => code?.discountCode?.obj?.custom?.fields?.applyDiscountOnMRP === true
  )
}

export const submitRazorpayOrder = async (
  setStepLoading,
  addPlaceOrderDataLayer,
) => {
  try {
    const cart = store.getState()?.cart
    const {
      general: { siteName = "", orderConfirmPath = "/", homepageUrl = "/" } = {},
    } = await getConfig()

    const orderConfirmUrl = await getShortenedUrl(orderConfirmPath)
    const homePagePath = await getShortenedUrl(homepageUrl)

    const {
      id: cartId,
      version,
      shippingAddress: { postalCode: pincode = "" } = {},
      promoCode
    } = cart.cart
    const { paymentId } = cart
    const _appliedCouponCode = promoCode[0]?.code
    const payload = {
      cartId,
      version,
      pincode
    }

    if (paymentId) {
      payload.paymentId = paymentId
    } else {
      payload.paymentStatus = "payment-pending"
    }

    const res = await store.dispatch(orderSubmit(payload)).unwrap()
    if (res) {
      const orderNumber = res.order?.orderNumber ?? ""
      const orderId = res.order?.id ?? ""
      const email = res.order?.customerEmail ?? ""
      const date = res.order?.createdAt ?? ""
      const total = res.order?.totalPrice?.centAmount ?? ""
      const fractionDigits = res.order?.totalPrice?.fractionDigits ?? 2
      const shippingAddress = res.order?.shippingAddress ?? {}

      gtmPurchaseEvent(
        orderId,
        email,
        shippingAddress,
        (total / 10 ** fractionDigits).toString(),
        _appliedCouponCode
      )

      const base64Str = btoa(JSON.stringify({ email, date, total }))
      const redirectionLink = `${orderConfirmUrl}?orderNumber=${orderNumber}&q=${base64Str}&oId=${orderId}`
      const purchasePathAnalytics = getPurchasePathAnalytics(
        res.order?.lineItems
      )
      addPlaceOrderDataLayer && addPlaceOrderDataLayer(redirectionLink, purchasePathAnalytics)

      const isRegCheckout = window.localStorage.getItem("regular-checkout")
      if (isRegCheckout === "true") {
        window.localStorage.removeItem("active-cart")
        window.localStorage.removeItem("regular-checkout")
        await store.dispatch(createCart({ currency: "INR" }))
      }

      window.localStorage.setItem("buy-now-init", "completed")
      window.localStorage.removeItem("buy-now-cart")
      window.history.replaceState(null, null, homePagePath)
      window.location.href = redirectionLink

    } else {
      setStepLoading && setStepLoading(false) // enable Place Order CTA on failure
    }
  } catch (error) {
    setStepLoading && setStepLoading(false)
    await store.dispatch(getCart()).unwrap()
    await refreshCart()
    setTimeout(location.reload(), 1000)
    throw error
  }
}

const postPaymentStepsClosure = function () {
  const _identyfier = Math.floor(Math.random() * 9000000000) + 1000000000;
  const executionDepth = [_identyfier]
  const updateExecutionDepth = function (val, payment_redirect) {
    if (payment_redirect === "true") {
      executionDepth.push(val)
    }
  }
  const getExecutionDepth = function () {
    return executionDepth
  }
  return {
    updateExecutionDepth, getExecutionDepth
  }
}

const { updateExecutionDepth, getExecutionDepth } = postPaymentStepsClosure()

const triggerPurchaseProccAnalytics = (debug_depth, trigger_point, razorpayResp, paymentResp, source, payment_redirect, additionalInfo) => {
  if (payment_redirect === "true") {
    const { razorpay_order_id, razorpay_payment_id } = razorpayResp || {}
    let isPaymentResp = paymentResp && paymentResp.length > 0 ? true : false
    const { adobeDataLayer: { getState } = {} } = window
    const page = getState?.("page") || {}
    const { pageInfo, site } = page
    const purchaseProccData = {
      "event": "cmp:purchaseProcessing",
      "eventInfo": {
        "orderID": razorpay_order_id,
        "payment_id": razorpay_payment_id,
        "payment_redirect": true,
        "source": source === 'razorpay' ? 'razorpay' : 'ccavenue',
        "debug_depth": debug_depth,
        "trigger_point": trigger_point,
        'isCCAvenueRes': isPaymentResp,
        "price": {
          "cartTotal": null,
          "currency": ""
        },
        "item": [
          {
            "productID": "",
            "quantity": null
          }
        ],
        "additionalInfo": {
          ...additionalInfo
        }
      },
      "page": {
        "site": {
          "environment": site?.environment,
          "siteName": site?.siteName,
          "platform": site?.platform,
          "language": site?.language
        },
        "pageInfo": {
          "pageName": pageInfo?.pageName,
          "pageUrl": pageInfo?.pageUrl,
          "referrer": pageInfo?.referrer,
          "previousPage": pageInfo.previousPage,
          "contentType": pageInfo?.contentType,
          "timestamp": pageInfo?.timestamp
        }
      }
    }
    window.adobeDataLayer.push(purchaseProccData)
  } else {
    return
  }
}

export {
  getShippingEventInfo,
  setPanConsent,
  updateExecutionDepth,
  getExecutionDepth,
  triggerPurchaseProccAnalytics
}
